// extracted by mini-css-extract-plugin
export default {"text":"MissedPaymentReason_text__kmsHV","inputContainer":"MissedPaymentReason_inputContainer__qZlbD","skeletonLoadingAnimation":"MissedPaymentReason_skeletonLoadingAnimation__DYvZO"};